const Promise = window.Promise || require('promise')
const request = require('superagent-promise')(require('superagent'), Promise)
const API_END_POINT = 'https://api.wirforce.com.tw/v2017'
const TICKETS = API_END_POINT + '/tickets'

const generateResponse = (res) => {
  const response = JSON.parse(res.text)
  if (typeof response.data !== 'undefined' && typeof response.data === 'object') {
    if (typeof response.paginator !== 'undefined' && typeof response.paginator === 'object') {
      return Promise.resolve(response)
    }
    return Promise.resolve(response.data)
  } else if (typeof response.data === 'undefined' && response.error.code === 200) {
    return Promise.resolve(null)
  } else {
    return Promise.reject({
      code: response.error.code,
      type: response.error.type,
      error: response.error
    })
  }
}

const generateErrorResponse = (err) => {
  console.log('error', err)
  return Promise.reject({
    err: err
  })
}

export default {
  API_END_POINT: API_END_POINT,
  query (token, account) {
    let req = request.get(API_END_POINT + '/account/query').query({ account: account })
    return req
      .send()
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  },
  ticketTypes (token, account) {
    let req = request.get(TICKETS)
    return req
      .send()
      .end()
      .then(generateResponse, generateErrorResponse)
  },
  rigester (token, params) {
    console.log('rigesterSingle')
    let req = request.post(TICKETS + '/' + params.ticketId + '/register')
    return req
      .type('form')
      .send({'id_number': params.id_number})
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  },
  rigesterGroup (token, params) {
    console.log('rigesterGroup', params)
    let req = request.post(TICKETS + '/' + params.ticketId + '/group/register')
    return req
      .type('form')
      .send({'group[account][]': params.account})
      .send({'group[id_number][]': params.id_number})
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/tickets.js